/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankAccountDetails
 */
export interface BankAccountDetails {
    /**
     * 
     * @type {string}
     * @memberof BankAccountDetails
     */
    bankName?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDetails
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDetails
     */
    accountType?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDetails
     */
    branchCode?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDetails
     */
    accountHolderName?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDetails
     */
    accountHolderIdNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDetails
     */
    accountHolderType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BankAccountDetails
     */
    verifiedStatus?: boolean;
}

/**
 * Check if a given object implements the BankAccountDetails interface.
 */
export function instanceOfBankAccountDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BankAccountDetailsFromJSON(json: any): BankAccountDetails {
    return BankAccountDetailsFromJSONTyped(json, false);
}

export function BankAccountDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankAccountDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bankName': !exists(json, 'BankName') ? undefined : json['BankName'],
        'accountNumber': !exists(json, 'AccountNumber') ? undefined : json['AccountNumber'],
        'accountType': !exists(json, 'AccountType') ? undefined : json['AccountType'],
        'branchCode': !exists(json, 'BranchCode') ? undefined : json['BranchCode'],
        'accountHolderName': !exists(json, 'AccountHolderName') ? undefined : json['AccountHolderName'],
        'accountHolderIdNumber': !exists(json, 'AccountHolderIdNumber') ? undefined : json['AccountHolderIdNumber'],
        'accountHolderType': !exists(json, 'AccountHolderType') ? undefined : json['AccountHolderType'],
        'verifiedStatus': !exists(json, 'VerifiedStatus') ? undefined : json['VerifiedStatus'],
    };
}

export function BankAccountDetailsToJSON(value?: BankAccountDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'BankName': value.bankName,
        'AccountNumber': value.accountNumber,
        'AccountType': value.accountType,
        'BranchCode': value.branchCode,
        'AccountHolderName': value.accountHolderName,
        'AccountHolderIdNumber': value.accountHolderIdNumber,
        'AccountHolderType': value.accountHolderType,
        'VerifiedStatus': value.verifiedStatus,
    };
}

